(function($){
  "use strict";
  require("../../node_modules/chosen-npm/public/chosen.jquery.min.js");
  console.log(apiVars.flixEndpoint);

  var dataTable = $('#flix').DataTable( {
    "processing": true,
    "serverSide": true,
    "ajax": apiVars.flixEndpoint,
    "columns": [
      {
        "data": "title.name",
        "render": function ( data, type, full, meta ) {
          return '<a href="'+full.link+'">'+data+'</a>';
        }
      },
      {
        "data": "moods.names",
        orderable: false
      },
      {
        "data": "genres.names",
        orderable: false
      },
      { "data": "length" },
      { "data": "complexity" },
    ]
  } );


  dataTable.on("xhr.dt", function(e, settings, data){
    if($("#moodselect option").length == 0){
      for (var i = 0; i < data.moods.length; i++) {
        $("#moodselect").append($("<option></option>")
                    .attr("value",data.moods[i].term_id)
                    .text(data.moods[i].name));
        // console.log(data.moods[i]);
      }
      $("#moodselect").chosen({width:"100%"});
    }

    if($("#genreselect option").length == 0){
      for (var i = 0; i < data.genres.length; i++) {
        $("#genreselect").append($("<option></option>")
                    .attr("value",data.genres[i].term_id)
                    .text(data.genres[i].name));
      }
      $("#genreselect").chosen({width:"100%"});
    }
    console.log(data);
  });

  dataTable.on("preXhr.dt", function(e, settings, data){
    if($("#moodselect").val()){
      data.moods = $("#moodselect").val();
    }
    if($("#genreselect").val()){
      data.genres = $("#genreselect").val();
    }
  });

  $("#moodselect, #genreselect").on("change", function(){
    dataTable.ajax.reload();
  });
})(jQuery);



/*****************
 ** WEBPACK FOOTER
 ** ./dev/js/main.js
 ** module id = 0
 ** module chunks = 0
 **/